import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for  filter trade 
export const filtertrade = createSlice({
  name: "filtertrade",
  initialState: {
    isLoading: false,
    isSuccess: false,
    api_completed: false,
    isFirst: true,
    data: {},
  },
  reducers: {
    edit_filtertrade: (state, action) => {
      state.data = action.payload;
    },
    success_api_call_filtertrade: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
      state.isFirst = true;
    },
    failure_api_call_filtertrade: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.api_completed = true;
      state.isSuccess = false;
    },
    filtertrade_is_success: (state) => {
      state.isSuccess = false;
    },
    filtertrade_complete_api: (state) => {
      state.api_completed = false;
    },
  },
});
export default filtertrade.reducer;
export const {
  edit_filtertrade,
  success_api_call_filtertrade,
  filtertrade_complete_api,
  failure_api_call_filtertrade,
  filtertrade_is_success,
} = filtertrade.actions;
